export enum LANGUAGES {
  FR = 'fr',
  EN = 'en',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  PT = 'pt',
  NL = 'nl',
  PL = 'pl',
  SV = 'sv',
  FI = 'fi',
  NO = 'no',
  DA = 'da',
  CS = 'cs',
  HU = 'hu',
  RO = 'ro',
  EL = 'el',
  TR = 'tr',
  BG = 'bg',
  BE = 'be',
  CH = 'ch',
}

export const availableNamedLanguages: LANGUAGES[] = [
  LANGUAGES.FR,
  LANGUAGES.EN,
  LANGUAGES.DE,
  LANGUAGES.ES,
  LANGUAGES.IT,
  LANGUAGES.PT,
  LANGUAGES.NL,
  LANGUAGES.PL,
  LANGUAGES.SV,
  LANGUAGES.FI,
  LANGUAGES.NO,
  LANGUAGES.DA,
  LANGUAGES.CS,
  LANGUAGES.HU,
  LANGUAGES.RO,
  LANGUAGES.EL,
  LANGUAGES.TR,
  LANGUAGES.BG,
];
